import { render } from "./getSnapChatToken.vue?vue&type=template&id=af8a01c8"
import script from "./getSnapChatToken.vue?vue&type=script&lang=js"
export * from "./getSnapChatToken.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__